import React from 'react';
import Bubble from './bubble';
import { matchesColors, fontFamily } from '../../../library/constants';
import { getExpandedHeightForBubble, isMobilePhone } from '../../../library/calc';
import { Triangletip, Trianglehide } from './triangletip';
import {
  TreematchBox,
  TmLabel,
  TreeMatchIcon,
  TreematchTransparentEventBox
} from './tm';
import {
   RemotematchBox,
   RmLabel,
   RemotematchGraph,
   RemotematchGraphTip,
   RemotematchGraphFill,
   RecordMatchIcon,
   RemotematchTransparentEventBox,
  } from './rm';
import {
   SmartmatchBox,
   SmLabel,
   SmartmatchGraph,
   SmartmatchGraphTip,
   SmartmatchGraphFill,
   SmartMatchIcon,
   SmartmatchTransparentEventBox,
  } from './sm';
import { Vsum } from './vsum';

export default ({
    n,
    vsum,
    matchBubbleContent,
    matchBubbleContentVarStr,
    fillMatchBubbleContent,
    left,
    top,
    stopStageClickPropagation,
    p,
    pr_id,
    updated,
    nn,
    nm,
    tm,
    rm,
    sm,
    nodeShownInMatchBubble,
    sm_vscore,
    rm_vscore,
    match_count,
    smartImg,
    recordImg,
    geniImg,
    cursorBecomesMove,
    cursorBecomesPointer,
    userTouchedNode,
  }) => {

  const fontSizeMatchLabel = 3.5;
  const fontFamilyMatchLabel = fontFamily;

  // vsum = 'Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur';

  let expandHeightBy = getExpandedHeightForBubble({content: vsum, fontSizeMatchLabel, fontFamilyMatchLabel, width: 60});
  const defaultBubbleBodyHeight = 16.5;

  expandHeightBy = ( expandHeightBy < 3 ? 3.5: expandHeightBy);

  const topBubble = -13.5;
  let leftBubble = -3;

  if(isMobilePhone()){
    leftBubble += 1;
  } else {
    if(parseInt(match_count, 10) > 10) leftBubble += 1.4;
    if(match_count === '99+') leftBubble += 1.8;
  }

  const props = {
    n,
    vsum,
    left,
    top,
    stopStageClickPropagation,
    cursorBecomesMove,
    cursorBecomesPointer,
    p,
    pr_id,
    updated,
    nn,
    nm,
    tm,
    rm,
    sm,
    matchesColors,
    leftBubble,
  };

  const bubbleProps = {
      ...props,
      yCoord4Bubble: topBubble - 12.6 - expandHeightBy,
      bubbleBodyHeight: defaultBubbleBodyHeight + expandHeightBy,
      bubbleBodyWidth: 66,
      strokeWidth: .3,
  };

  const onTouchMatch = (href) => {

    userTouchedNode({
      node: n,
      callback: ()=>{
        window.open(href, '_blank');
        //window.safari.self.browserWindow.openTab();
      },
      fromWhere: 'matchBubble'});
  }

  const paddingTopBubble = 3;
  const paddingMatchBox = 5;
  const matchBoxProps = {
      ...props,
      fillMatchBubbleContent,
      matchBubbleContent,
      matchBubbleContentVarStr,
      onTouchMatch,
      yCoord4Matchbox: bubbleProps.yCoord4Bubble + paddingTopBubble,
      width4Matchbox: 19,
      leftStart4Boxes: leftBubble + 2.5,
      paddingBetweenBoxes: 2,
      topMatchLabel: topBubble - paddingTopBubble - paddingMatchBox - expandHeightBy,
      leftStart4MatchLabel: 7.3,
      fontSizeMatchCount: 4,
      fontSizeMatchLabel,
      fontFamilyMatchLabel,
      matchBoxHeight: 10,
      textWidth: 12,
  };

  const matchGraphProps = {
      sm_vscore,
      rm_vscore,
      leftMargin: 4,
      topStart4Graph: 7,
      width4graph: matchBoxProps.width4Matchbox - 7,
      cornerRadius: .65,
      height4Graph: 1,
      fillcolor: 'lightgray',
      defaultWidth4Graph: 13
  };

  // const treeImage = new window.Image();
  // treeImage.src = imageBasePath + 'treematch.svg';

  // const wandImage = new window.Image();
  // wandImage.src = imageBasePath + 'smartmatch.svg';

  // const bookImage = new window.Image();
  // bookImage.src = imageBasePath + 'recordmatch.svg';

  const treeMatchIconProps = {
      leftStart4Icon: -2.5,
      iconWidth: 4.1,
      smartImg,
      recordImg,
      geniImg,
  };

  return [
    <Bubble  key={Math.random()} {...bubbleProps}/>,
    <Triangletip  key={Math.random()} {...bubbleProps}/>,
    <Trianglehide  key={Math.random()} {...bubbleProps}/>,

    <TreematchBox key={Math.random()} {...matchBoxProps} />,
    <TmLabel key={Math.random()} {...matchBoxProps} />,
    <TreeMatchIcon key={Math.random()} {...matchBoxProps} {...matchGraphProps} {...treeMatchIconProps}/>,
    <TreematchTransparentEventBox key={Math.random()} {...matchBoxProps} />,

    <RemotematchBox key={Math.random()} {...matchBoxProps} />,
    <RmLabel key={Math.random()} {...matchBoxProps} />,
    <RemotematchGraph key={Math.random()} {...matchBoxProps} {...matchGraphProps}/>,
    <RecordMatchIcon key={Math.random()} {...matchBoxProps} {...matchGraphProps}  {...treeMatchIconProps}/>,
    <RemotematchGraphTip key={Math.random()} {...matchBoxProps} {...matchGraphProps}/>,
    <RemotematchGraphFill key={Math.random()} {...matchBoxProps} {...matchGraphProps}/>,
    <RemotematchTransparentEventBox key={Math.random()} {...matchBoxProps} />,

    <SmartmatchBox key={Math.random()} {...matchBoxProps} />,
    <SmartMatchIcon key={Math.random()} {...matchBoxProps} {...matchGraphProps}  {...treeMatchIconProps}/>,
    <SmLabel key={Math.random()} {...matchBoxProps} />,
    <SmartmatchGraph key={Math.random()} {...matchBoxProps} {...matchGraphProps}/>,
    <SmartmatchGraphTip key={Math.random()} {...matchBoxProps} {...matchGraphProps}/>,
    <SmartmatchGraphFill key={Math.random()} {...matchBoxProps} {...matchGraphProps}/>,
    <SmartmatchTransparentEventBox key={Math.random()} {...matchBoxProps} />,

    <Vsum key={Math.random()} {...matchBoxProps}/>,
  ];
};

